import {getSiteUrl} from "@/helpers/functions";

export interface SeoSchemaSpecialAnnouncementProps {
    name: string;
    text: string;
    datePosted: string;
    expires?: string;
    url: string;
    category?: string;
}

const toAbsoluteUrl = (siteUrl: string, url: string): string => {
    if (/^https?:\/\//i.test(url)) return url;
    return `${siteUrl}${url.startsWith("/") ? "" : "/"}${url}`;
};

export function SeoSchemaSpecialAnnouncement({name, text, datePosted, expires, url, category}: SeoSchemaSpecialAnnouncementProps) {
    const siteUrl = getSiteUrl();
    const schema: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "SpecialAnnouncement",
        "name": name,
        "text": text,
        "datePosted": datePosted,
        "url": toAbsoluteUrl(siteUrl, url),
        "publisher": {"@id": `${siteUrl}/#organization`},
    };
    if (expires) schema.expires = expires;
    if (category) schema.category = category;
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(schema)}}
        />
    );
}
